import { render, staticRenderFns } from "./areaCommunityBind.vue?vue&type=template&id=089a7f3f&scoped=true"
import script from "./areaCommunityBind.vue?vue&type=script&lang=js"
export * from "./areaCommunityBind.vue?vue&type=script&lang=js"
import style0 from "./areaCommunityBind.vue?vue&type=style&index=0&id=089a7f3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089a7f3f",
  null
  
)

export default component.exports